export default __webpack_public_path__ + "static/media/splitDay.575475d2.svg";